import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import { useRole } from "components/Hooks/UserHooks";
import CountUp from "react-countup";
import { getmanualPush } from "store/notification/thunk";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownStatus from "components/Common/DropdownStatus";
import {
  MANUAL_PUSH_REDIRECT_SCREEN_TARGET,
  MANUAL_PUSH_STATUS,
  COLOR_MANUAL_PUSH_STATUS,
  AGENCY_APP_NAME_OPTION,
  LIST_OPTION_SOURCE_APP,
  MANUAL_PUSH_SEND_TIME_OPTION,
  COLOR_MANUAL_PUSH_SEND_TIME,
  LIST_OPTION_OS,
  USER_TYPE_LOG_OPTION,
  COLOR_USER_TYPE_LOG,
  COLOR_MANUAL_PUSH_SAVE_OPTION,
  MANUAL_PUSH_SAVE_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC, formatNumberWithCommas, getOptionImage, getPlatFormImage } from "helpers/format";
import { capitalizeFirstLetter } from "utils";
import CollapseContent from "components/Common/CollapseContent";
import TooltipCustom from "components/Common/TooltipCustom";
import CopyWrapper from "components/Common/CopyWrapper";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import CreateEditPush from "./CreateEditPush";
import CoundownTime from "components/Common/CoundownTime";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import { Link } from "react-router-dom";
import ModalConfirm from "components/Common/ModalConfirm";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import PushNotificationApi from "api/notificationApi";
import ModalUserLog from "./ModalUserLog";
import avatar1 from "../../../assets/images/users/ic_defaul_avatar2.png";
import ModalUserParams from "./ModalUserParams";
import ModalPreview from "components/Common/ModalPreview";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "createdAt";

registerLocale("en", en);
registerLocale("ko", ko);

const ManualPush = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const { userPermissions } = useRole();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(null);
  const [itemToUserLog, setItemToUserLog] = useState<any>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    title: withDefault(StringParam, ""),
    body: withDefault(StringParam, ""),
    uuid: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    nickname: withDefault(StringParam, ""),
    app_name: withDefault(StringParam, ""),
    os: withDefault(StringParam, ""),
    notify_action: withDefault(StringParam, ""),
    notify_type: withDefault(StringParam, ""),
    push_status: withDefault(StringParam, ""),
    open_status: withDefault(StringParam, ""),
    user_type: withDefault(StringParam, ""),
    send_type: withDefault(StringParam, ""),
    start_date: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).startOf("day").subtract(7, 'days').format("Y-MM-DD HH:mm:ss")
      )
    ),
    end_date: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
  });

  const MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG =
    MANUAL_PUSH_REDIRECT_SCREEN_TARGET?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const LIST_OPTION_PUSH_STATUS_LANG =
    MANUAL_PUSH_STATUS?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [titleSearch, setTitleSearch] = useState<string>(
    query?.title || ""
  );

  const [contentSearch, setContentSearch] = useState<string>(
    query?.body || ""
  );

  const [redirectScreenTargetSearch, setRedirectScreenTargetSearch] =
    useState<any>(
      MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG?.find(
        (i: any) => i?.value == query?.notify_action
      ) || ""
    );

  const [pushStatusSearch, setPushStatusSearch] = useState<Option | null>(
    LIST_OPTION_PUSH_STATUS_LANG?.find(
      (item) => String(item?.value) === String(query?.["push_status"])
    ) || null
  );

  const [sendTimeSearch, setSendTimeSearch] = useState<any>(
    MANUAL_PUSH_SEND_TIME_OPTION?.find(
      (item) => item?.value === query?.send_type
    )?.value || ""
  );

  const [appNameSearch, setAppNameSearch] = useState<Option | any>(
    AGENCY_APP_NAME_OPTION?.find((item) => item?.value === query?.app_name)
      ?.value || ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    moment(new Date(), "Y-MM-DD HH:mm:ss").subtract(7, 'days').toDate(),
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
  ]);
  const [start_date, end_date] = dateSearch;

  const selectLayoutState = (state: any) => state.PushNotification;
  const manualPushProperties = createSelector(selectLayoutState, (state) => {
    return {
      manualPush: state?.manualPush,
      isManualPushLoading: state?.isManualPushLoading,
      isManualPushSuccess: state?.isManualPushSuccess,
    };
  });

  // Inside your component
  const { manualPush, isManualPushLoading } = useSelector(manualPushProperties);
  function loadTableData() {
    dispatch(getmanualPush(query));
  }

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      title: titleSearch || "",
      body: contentSearch || "",
      notify_action: redirectScreenTargetSearch || "",
      push_status: pushStatusSearch?.value || "",
      app_name: appNameSearch || "",
      send_type: sendTimeSearch || "",

      start_date: start_date
        ? formatDateStringToUTC(
          moment(new Date(start_date))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      end_date: end_date
        ? formatDateStringToUTC(
          moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      time_request: +new Date(),
      page: 1,
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        body: "",
        app_name: "",
        notify_action: "",
        push_status: "",
        send_type: "",
        start_date: formatDateStringToUTC(
          moment(`${moment().format("Y-MM-DD")}`, "Y-MM-DD").subtract(7, 'days').startOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        end_date: formatDateStringToUTC(
          moment(`${moment().format("Y-MM-DD")}`, "Y-MM-DD").endOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setTitleSearch((_prev) => "");
    setContentSearch((_prev) => "");
    setAppNameSearch("");
    setSendTimeSearch("");
    setRedirectScreenTargetSearch(null);
    setPushStatusSearch(null);
    setDateSearch([
      moment(`${moment().format("Y-MM-DD")}`, "Y-MM-DD").subtract(7, 'days').toDate(),
      moment(`${moment().format("Y-MM-DD")}`, "Y-MM-DD").toDate(),
    ]);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div>
              {manualPush?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },

      {
        Header: t("App"),
        accessor: "app_name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          const item = cell?.value;
          let imgAppName = item !== "all" && getOptionImage(item);

          return (
            item && (
              <div className="d-flex align-items-center whitespace-nowrap">
                {imgAppName && (
                  <div style={{ width: "25px" }} className="me-1">
                    <img
                      src={imgAppName}
                      width={20}
                      height={20}
                      alt="platform"
                    />
                  </div>
                )}
                <div>
                  {t(
                    LIST_OPTION_SOURCE_APP?.find(
                      (item: any) => item?.value === cell?.value
                    )?.label || t(capitalizeFirstLetter(item))
                  )}
                </div>
              </div>
            )
          );
        },
      },

      {
        Header: t("Send Status"),
        accessor: "push_status",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          const item = cell?.row?.original;
          const pushDate = item?.date_send;
          const pushDateKorean = formatDateStringToKorea(pushDate);
          const detailError = item?.detailError;
          const msgError =
            i18n?.language === "en" ? detailError?.en : detailError?.ko;
          const minWidth: string | number =
            i18n?.language === "en" ? "125px" : "96px";

          const sentUserCount = item?.sent_user_count > 0 ? item?.sent_user_count : 0;
          const totalPushUser = item?.total_push_user > 0 ? item?.total_push_user : 0;

          return (
            <div className="position-relative" style={{ minWidth: minWidth }}>
              <div className={`text-center mt-0 fs-13 text-${Number(item?.sent_user_count) === Number(item?.total_push_user) ? 'primary' : 'danger'} `}>{formatNumberWithCommas(item?.sent_user_count)}<span style={{ margin: '0px 2px' }}>/</span>{formatNumberWithCommas(item?.total_push_user)}</div>
              <div className="text-center" style={{ lineHeight: "16px" }}>
                {
                  status === 'waiting' ? (
                    <div className="text-center">
                      <CoundownTime expireDate={pushDateKorean} type="push-log" pushLogId={item?.id} triggerRefresh={triggerRefresh} />

                      {/* <SendStatusAction idPushLog={item?.id} triggerRefresh={triggerRefresh} /> */}
                    </div>
                  ) : (
                    <span
                      className={`rounded-pill badge bg-${COLOR_MANUAL_PUSH_STATUS[status] || "secondary"
                        }`}
                    >
                      {t(
                        LIST_OPTION_PUSH_STATUS_LANG?.find(
                          (item: any) => String(item?.value) === String(status)
                        )?.label ?? ""
                      )}
                    </span>
                  )
                }
              </div>
              {
                (status === "processing") && (
                  sentUserCount > 0 || totalPushUser > 0 ? (
                    <small className="text-blue text-center w-100 d-block">
                      {`${sentUserCount}/${totalPushUser}`}
                    </small>
                  ) :
                    <>
                      <TooltipCustom
                        title={t('No device tokens found (Push skipped)')}
                        className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                        style={{
                          transform: "translateY(2px)",
                          position: "absolute",
                          top: -3,
                          right: 0,
                          paddingLeft: 4,
                          paddingRight: 3,
                        }}
                      >
                        <i
                          className="ri-question-line align-bottom text-secondary"
                          style={{ fontSize: "16px" }}
                        ></i>
                      </TooltipCustom>
                    </>
                )
              }

              {status === "failed" && msgError && (
                <TooltipCustom
                  title={t(msgError)}
                  className="d-inline-block vertical-align-middle ms-1 thumbnail-mt"
                  style={{
                    transform: "translateY(2px)",
                    position: "absolute",
                    top: -3,
                    right: 0,
                    paddingLeft: 4,
                    paddingRight: 3,
                  }}
                >
                  <i
                    className="ri-question-line align-bottom text-secondary"
                    style={{ fontSize: "16px" }}
                  ></i>
                </TooltipCustom>
              )}
            </div>
          );
        },
      },

      {
        Header: t("Title"),
        accessor: "title",
        filterable: true,
        sortable: false,
        thWidth: 220,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const title = cell?.value;

          return cell?.value && (
            <CopyWrapper contentCopy={cell?.value} style={{ minWidth: "200px" }}>
              <CollapseContent
                style={{ maxWidth: "250px" }}
                dataOriginal={cell?.value}
                isRank={false}
                isInlineBlock={true}
                isShowModal={true}
                titleModal={t("Title")}
              />
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Content"),
        accessor: "body",
        filterable: true,
        sortable: false,
        thWidth: 250,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          return cell?.value && (
            <CopyWrapper contentCopy={cell?.value} style={{ minWidth: "220px" }}>
              <CollapseContent
                style={{ maxWidth: "350px" }}
                dataOriginal={cell?.value}
                isRank={false}
                isInlineBlock={true}
                isShowModal={true}
                titleModal={t("Content")}
              />
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Send Time"),
        accessor: "send_type",
        filterable: true,
        sortable: false,
        thWidth: 250,
        thClass: "whitespace-nowrap text-center",
        Cell: (cell: any) => {
          return cell?.value && (
            <div style={{ lineHeight: "16px", minWidth: "90px" }} className="text-center">
              <span
                className={`rounded-pill badge bg-${COLOR_MANUAL_PUSH_SEND_TIME[cell?.value] || "secondary"
                  }`}
              >
                {t(
                  MANUAL_PUSH_SEND_TIME_OPTION?.find(
                    (item: any) => String(item?.value) === String(cell?.value)
                  )?.label ?? ""
                )}
              </span>
            </div>
          );
        },
      },

      {
        Header: t("Open Type"),
        accessor: "notify_action",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="" style={{ minWidth: 120 }}>
              {
                MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG.find(
                  (i: any) => i?.value == status
                )?.label
              }
            </div>
          );
        },
      },
      {
        Header: t("User Type"),
        accessor: "user_type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const userType = cell?.value;
          const userTypeText = USER_TYPE_LOG_OPTION?.find(
            (item: any) => String(item?.value) === String(userType)
          )?.label;

          return (
            <div style={{ minWidth: 100 }}>
              {
                userTypeText ? (
                  <div style={{ minWidth: 80 }}>
                    <span
                      className={`rounded-pill badge bg-${COLOR_USER_TYPE_LOG[userType] || "secondary"
                        }`}
                    >
                      {t(
                        USER_TYPE_LOG_OPTION?.find(
                          (item: any) => String(item?.value) === String(userType)
                        )?.label || ''
                      )}
                    </span>
                  </div>
                ) : (t(capitalizeFirstLetter(userType)))
              }
            </div>
          );
        },
      },
      {
        Header: t("Save Notification"),
        accessor: "save_option",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_MANUAL_PUSH_SAVE_OPTION[status] || "secondary"
                  }`}
              >
                {t(
                  MANUAL_PUSH_SAVE_OPTION?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Target"),
        accessor: "target_value",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 300,
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            cell?.value ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },

      {
        Header: t("deviceOS"),
        accessor: "device_os",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.value;
          let imgOS = getPlatFormImage(deviceOS);

          return (
            deviceOS && (
              <div
                className="d-flex align-items-center"
                style={{ minWidth: "110px" }}
              >
                {imgOS ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgOS ? (
                      <img src={imgOS} width={20} height={20} alt="platform" />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                      ?.label ?? "All"
                  )}
                </div>
              </div>
            )
          );
        },
      },

      {
        Header: t("Users"),
        accessor: "target_users",
        filterable: false,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 300,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const allUser = cell?.value;
          let shortKeyword = [];

          if (allUser?.length > 5) {
            shortKeyword = [...allUser].splice(0, 5);
          } else {
            shortKeyword = allUser;
          }

          return (
            shortKeyword?.length > 0 ? (
              <div>
                <div className="d-flex gap-1" style={{ flexWrap: 'wrap', minWidth: 280 }}>
                  {shortKeyword?.map((item: any, index: number) => {

                    return (
                      <div
                        className="d-flex align-items-center gap-2"
                        style={{ minWidth: "175px" }}
                        key={item?.id}
                      >
                        <div
                          style={{
                            height: "35px",
                            width: "35px",
                            overflow: "hidden",
                            borderRadius: "15px",
                            backgroundColor: "#eaeaea",
                            minWidth: "35px",
                            marginTop: "2px",
                          }}
                        >
                          <img
                            src={item?.profile_image_url || avatar1}
                            alt={item?.nickname}
                            height={35}
                            width={35}
                            className="me-2"
                            style={{
                              overflow: "hidden",
                              borderRadius: "50%",
                              objectFit: "cover",
                              backgroundColor: "#eaeaea",
                            }}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = avatar1;
                            }}
                          />
                        </div>
                        <div>
                          {`${item?.nickname}`} <br />
                          {item?.email}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {allUser?.length > 5 && (
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToUserLog(item)
                    }}
                    style={{
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                    className="link-primary fs-12 d-inline"
                  >
                    <span>{t("View More")}</span>
                    <i
                      className={`ri-arrow-up-s-line fs-16 position-relative`}
                      style={{ top: "4px" }}
                    ></i>
                  </span>
                )}
              </div>
            ) : (
              t('All')
            )
          );
        },
      },
      {
        Header: t("Province/Metropolitan City"),
        accessor: "region1",
        filterable: false,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const regions = cell?.value ? cell?.value?.split(',') : [];

          return regions?.length > 0 ? (
            <div className="d-flex gap-2 flex-wrap" style={{ lineHeight: "16px", minWidth: "90px" }}>
              {regions?.map((item: any, index: number) => {
                return item !== 'all' ? <span
                  className={`rounded-pill badge bg-primary`}
                  key={index}
                >
                  {`${item}`}
                </span> : "-"
              })}
            </div>
          ) : "-";
        },
      },
      {
        Header: t("City/District"),
        accessor: "region2",
        filterable: false,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const regions = cell?.value ? cell?.value?.split(',') : [];

          return regions?.length > 0 ? (
            <div className="d-flex gap-2 flex-wrap" style={{ lineHeight: "16px", minWidth: "90px" }}>
              {regions?.map((item: any, index: number) => {
                return item !== 'all' ? <span
                  className={`rounded-pill badge bg-primary`}
                  key={index}
                >
                  {`${item}`}
                </span> : "-"
              })}
            </div>
          ) : "-";
        },
      },
      {
        Header: t("Town/Neighborhood"),
        accessor: "region3",
        filterable: false,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const regions = cell?.value ? cell?.value?.split(',') : [];

          return regions?.length > 0 ? (
            <div className="d-flex gap-2 flex-wrap" style={{ lineHeight: "16px", minWidth: "90px" }}>
              {regions?.map((item: any, index: number) => {
                return item !== 'all' ? <span
                  className={`rounded-pill badge bg-primary`}
                  key={index}
                >
                  {`${item}`}
                </span> : "-"
              })}
            </div>
          ) : "-";
        },
      },
      {
        Header: t("Operator"),
        accessor: "admin",
        filterable: false,
        sortable: false,
        thClass: "whitespace-nowrap text-end",
        thWidth: 200,
        Cell: (cell: any) => {
          const firstName = cell?.value?.first_name;
          const email = cell?.value?.email;

          return (firstName || email) ? (
            <div className="d-flex gap-1 flex-column justify-content-end text-end" style={{ lineHeight: "16px", minWidth: "150px" }}>
              <div>{firstName}</div>
              <small className="text-secondary" style={{ color: "#878a99" }}>{email}</small>
            </div>
          ) : "-";
        },
      },
      {
        Header: t("Sent at"),
        accessor: "date_send",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (item?.send_type === 'schedule' && item?.push_status === 'waiting') && (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "120px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, manualPush?.pagination?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await PushNotificationApi.putManualSendStatus(id, {
        status: 'delete',
      });

      if (response?.data) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseCommentClick = () => {
    setItemToUserLog(null);
  };

  useEffect(() => {
    document.title = `${t("Send Push (Manual)")} - ${t("Push Notification")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    // const handleCallAllOption = async () => {
    //   try {
    //     const [resUsers]: any = await Promise.all([
    //       userApi.users({ page: 1, limit: 20000 })
    //     ]);
    //     let dataUsersOption: any = [];
    //     if (resUsers?.data?.items) {
    //       dataUsersOption = resUsers?.data?.items?.map((a: any) => ({
    //         value: String(a?._id),
    //         label: (
    //           <div className="d-flex align-items-center gap-2">
    //             {`${a?.nickname} - ${a?.email}`}
    //           </div>
    //         ),
    //         data: a,
    //       })) as Option[]
    //     }
    //     setListUsers((_prev: any) => dataUsersOption)
    //   } catch (error: any) {
    //     return error;
    //   }
    // };
    // handleCallAllOption();
  }, []);

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Send Push (Manual)")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={manualPush?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Create Push")}
                      </button>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Title")}
                          isShow={false}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Title")}...`}
                            value={titleSearch}
                            onChange={(e) => setTitleSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Content")}
                          isShow={false}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Content")}...`}
                            value={contentSearch}
                            onChange={(e) => setContentSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Open Type")}
                          isShow={true}
                        >
                          <DropdownOptionNew
                            name="redirectScreenTarget"
                            dataList={
                              MANUAL_PUSH_REDIRECT_SCREEN_TARGET_LANG || []
                            }
                            placeholder={`${t("Open Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={redirectScreenTargetSearch || ""}
                            onChangeSelect={(e: any) =>
                              setRedirectScreenTargetSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            hideSelectedOptions={false}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Send Status")} isShow={true}>
                          <DropdownStatus
                            name="push-status"
                            dataList={LIST_OPTION_PUSH_STATUS_LANG || []}
                            placeholder={`${t("Send Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={pushStatusSearch || null}
                            onChangeSelect={(e: any) => setPushStatusSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_MANUAL_PUSH_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Send Time")} isShow={true}>
                          <DropdownStatusNew
                            name="send-status"
                            dataList={MANUAL_PUSH_SEND_TIME_OPTION || []}
                            placeholder={`${t("Send Time")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sendTimeSearch}
                            onChangeSelect={(e: any) => setSendTimeSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_MANUAL_PUSH_SEND_TIME}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="os"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3">
                        <LabelWrapper label={t("App")} isShow={true}>
                          <DropdownOptionNew
                            name="app_name"
                            dataList={LIST_SOURCE_APP_LANG || []}
                            placeholder={`${t("Select App Name")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sourceAppSearch}
                            onChangeSelect={(e: any) => setSourceAppSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            lstImage={true}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={USER_TYPE_LOG_OPTION || []}
                            placeholder={`${t("User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={isGuestSearch}
                            onChangeSelect={(e: any) =>
                              setIsGuestSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE_LOG}
                          />
                        </LabelWrapper>
                      </Col> */}

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("App")} isShow={true}>
                          <DropdownOptionNew
                            name="app_name"
                            dataList={LIST_OPTION_SOURCE_APP || []}
                            placeholder={`${t("Select App Name")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={appNameSearch}
                            onChangeSelect={(e: any) =>
                              setAppNameSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            lstImage={true}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        lg={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={manualPush?.list?.length ? manualPush?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={manualPush?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(manualPush?.pagination?.total) /
                        Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isManualPushLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <CreateEditPush
            itemToEdit={itemToEdit}
            onCloseClick={onCloseClick}
            setItemToEdit={setItemToEdit}
            loadTableData={loadTableData}
            triggerRefresh={triggerRefresh}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Schedule Message")}
            isOpen={!!itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        {itemToUserLog && (
          <ModalUserParams
            isOpen={true}
            item={itemToUserLog?.target_users}
            setLinkImage={setLinkImage}
            onClose={onCloseCommentClick}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default ManualPush;
